<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      :addBtn="false"
      :ableSearch="ableSearch"
    ></search-form>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'result'">
          {{ codeToText(record.result, loginState) }}
        </template>
        <template v-if="column.key === 'name'">
          {{ codeToText(record.user_id, Enum.user.value) }}
        </template>
        <template v-if="column.key === 'depart_id'">
          {{ codeToText(record.depart_id, Enum.dept.value) }}
        </template>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import { getOperationLog as getData } from '@/api/system_manage/log'
  import searchForm from '@/components/search_form'
  import dayjs from 'dayjs'
  import { codeToText, constantToOptions } from '@/utils/format'
  import { loginState } from '@/utils/common'
  //初始化
  const store = useStore()
  const Enum = toRefs(store.state.common)

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'operationLog:list')
  )

  //1、搜索框
  const formCollection = [
    {
      type: 'select',
      field: 'userId',
      storeOptions: 'user',
      label: '账号',
      width: '130px',
      'allow-clear': true,
    },
    {
      type: 'select',
      field: 'result',
      label: '操作结果',
      width: '130px',
      defaultValue: -1,
      options: [{label:"不限",value:"-1"},...constantToOptions(loginState)],
    },
    {
      type: 'dateRange',
      startField: 'startTime',
      endField: 'endTime',
      showTime: true,
      defaultStart: dayjs().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss'),
      defaultEnd: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      format: 'YYYY-MM-DD HH:mm:ss',
      label: '时间范围',
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
  }

  //2、表格
  const columns = [
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
    },
    {
      title: '账号',
      dataIndex: 'user_id',
      key: 'user_id',
      align: 'left',
    },
    {
      title: '部门',
      key: 'depart_id',
      dataIndex: 'depart_id',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'operation',
      key: 'operation',
      align: 'left',
    },
    {
      title: '结果',
      key: 'result',
      dataIndex: 'result',
      align: 'left',
    },
    {
      title: '操作时间',
      dataIndex: 'operate_time',
      key: 'operate_time',
      align: 'left',
    },
    {
      title: '请求地址',
      key: 'api',
      dataIndex: 'api',
      align: 'left',
    },
    {
      title: '请求方式',
      key: 'method',
      dataIndex: 'method',
      align: 'left',
    },
    {
      title: '请求参数',
      key: 'params',
      dataIndex: 'params',
      align: 'left',
      ellipsis: true,
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }
  onMounted(fetch)
</script>
